module.exports = __webpack_public_path__ + "img/rightstar.70e7f243.png";